module.exports = __webpack_public_path__ + "img/failed-login.7d20a6f4.svg";